export default [
  {
    path: "/reservation",
    meta: {
      hideLogo: true,
      hideAppBar: false,
      hideBottomNavigation: true,
      fullWidth: true,
      navbarTitle: "Reservationen",
      showBackButton: true,
      backTo: "/",
    },
    name: "ReservationTypeSelection",
    component: () => import("@/views/reservationTool/views/ReservationTypeSelection.vue"),
  },

  {
    path: "/reservation/:reservationTypeId",
    name: "ReservationBooking",
    meta: {
      hideLogo: true,
      hideAppBar: false,
      hideBottomNavigation: true,
      fullWidth: true,
      navbarTitle: "Reservationen",
      showBackButton: true,
      backTo: "/reservation",
    },
    component: () => import("@/views/reservationTool/ReservationTool.vue"),
  },
]
